import { DatePipe } from '@angular/common';
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct, NgbModal, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ProductoService } from '@abm/producto/producto.service';
import { UsuarioService } from '@account/usuario.service';
import { ModalMotivoRechazoComponent } from '@cliente/clientes-aprobar-modificaciones/modal-motivo-rechazo/modal-motivo-rechazo.component';
import { ModalSeleccionarUsuarioComponent } from '@precios/niveles-aprobacion/modal-seleccionar-usuario/modal-seleccionar-usuario.component';
import { EstadoRefacturacion } from '@shared/enums/estadoRefacturacion';
import { Motivo } from '@shared/enums/Motivo';
import { TipoMoneda } from '@shared/enums/tipoMoneda';
import { tipoNivelUsuarioSeparados } from '@shared/enums/tipoNivelUsuarioSeparados';
import { ModalOkComponent } from '@shared/generic-modals/modal-ok.component';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { Aerovale } from '@shared/models/despacho/Aerovale';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Comprobante } from '@shared/models/facturacion/Comprobante';
import { Factura } from '@shared/models/facturacion/Factura';
import { RefacturacionFactura } from '@shared/models/facturacion/RefacturacionFactura';
import { TuplaRefacturacion } from '@shared/models/facturacion/TuplaRefacturacion';
import { TipoMovimientoPipe } from '@shared/pipes/tipo-movimiento.pipe';
import { SharedService } from '@shared/shared.service';
import { MessageService } from '@shell/message.service';
import { ComprobanteService } from '../comprobante.service';
import { FacturacionService } from '../facturacion.service';
import { TipoModalObservacion } from "@shared/enums/TipoModalObservacion";
import { MotivosObservacionesComponent } from "@shared/components/motivos-observaciones/motivos-observaciones.component";
import { CondicionVenta } from '@shared/enums/condicionVenta';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AuthService } from '@authentication/auth.service';

@Component({
  selector: 'app-aprobacion-refacturacion',
  templateUrl: './aprobacion-refacturacion.component.html',
  styleUrls: ['./aprobacion-refacturacion.component.css']
})
export class AprobacionRefacturacionComponent implements OnInit, OnDestroy {

  @HostBinding('class.changed')

  tablaComprobantes: UntypedFormGroup;
  aeroplanta: Aeroplanta;

  tituloFactura: string;


  facturas: RefacturacionFactura[] = [];
  facturasFiltradas: RefacturacionFactura[] = [];

  facturasSeleccionadas: RefacturacionFactura[] = [];

  facturaCalculada: Factura[];
  facturaObtenida: Comprobante;
  remitosId: string[] = [];
  aerovaleDetalle: AerovaleDetalle;
  previsualizacion: boolean = false;

  aerovales: Aerovale[] = [];
  aerovalesFiltrados: Aerovale[] = [];
  aerovaleActual: Aerovale;
  fechaHasta = new UntypedFormControl();
  fechaFormControlDesdeHasta = new UntypedFormControl();
  mensajeErrorExportar = "";
  model: NgbDateStruct;
  model1: NgbDateStruct;
  time: NgbTimeStruct;
  startDate: Date;
  endDate: Date;
  buscando: boolean = false;
  mensajeSpinner: string = "D e s c a r g a n d o";
  obteniendoAerovales = true;
  procesandoExport: boolean = false;
  codigoAeroplanta: string;
  cambiandoAeroplanta: boolean = false;
  pendiente = { valor: "Pendiente", descripcion: "Pendiente", seleccionado: false };
  finalizado = { valor: "Finalizado", descripcion: "Finalizado", seleccionado: false };
  finalizadoSinFirma = { valor: "FinalizadoSinFirma", descripcion: "Finalizado sin firma", seleccionado: false };
  estadoSincronizado = { valor: "Sincronizado", descripcion: "Sincronizado", seleccionado: false };
  anulado = { valor: "Anulado", descripcion: "Anulado", seleccionado: false };

  notaCredito = { tipo: 0, valor: "notaCredito", descripcion: "Nota de credito", seleccionado: false };
  notaDebito = { tipo: 1, valor: "notaDebito", descripcion: "Nota de debito", seleccionado: false };

  tipos = [
    this.notaCredito, this.notaDebito
  ];

  cargandoPrevisualizacion: boolean = false;
  descargaArchivo: boolean = false;

  estados = [
    this.pendiente,
    this.finalizado,
    this.estadoSincronizado,
    this.anulado
  ];

  busquedaFormControl = new UntypedFormControl();
  change$: Subscription;
  errorAerovales: boolean = false;


  idComprobanteAsociado: string;
  botonAnular: boolean = false;
  cargandoNiveles: boolean;
  errorNiveles: string;
  mensajeNivelUsuario: string;
  cotizacionDolar: number = null;
  aceptandoRefacturacion: boolean = false;
  rechazandoRefacturacion: boolean = false;
  itemSeleccionado: number = null;
  motivo = Motivo;
  rolRefacturacion: boolean;

  constructor(private datepickerConfig2: NgbDatepickerConfig,
    private messageService: MessageService,
    private usuarioService: UsuarioService,
    private calendar: NgbCalendar,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private activeModal: NgbModal,
    private fb: UntypedFormBuilder,
    private comprobanteService: ComprobanteService,
    public facturacionService: FacturacionService,
    private productosService: ProductoService,
    private datePipe: DatePipe,
    private tipoMovimientoPipe: TipoMovimientoPipe,
    public sharedService: SharedService,
    private authService: AuthService) {
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(()=>{
        this.cambiarDeAeroplanta();
      });
  }

  ngOnInit() {
    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();
    const inicio: any = { day: 1, month: 1, year: 2019 };
    this.datepickerConfig2.minDate = inicio;
    const fin: any = { day: this.model.day, month: this.model.month, year: this.model.year };
    this.model1 = this.calendar.getToday();
    this.datepickerConfig2.maxDate = fin;
    if(this.authService.hasRole(TipoUsuario.FACTURACION) || this.authService.hasRole(TipoUsuario.REFACTURACION)){
      this.rolRefacturacion = true;
    } else this.rolRefacturacion = false;

    this.productosService.getCotizacionDolar()
      .subscribe(result => {
        this.cotizacionDolar = result;
        this.errorNiveles = null;

        this.facturacionService.getNivelesUsuario(this.usuarioService.getUsername())
          .subscribe(() => {
            console.log("Se cargaron los niveles del usuario");
            this.cargandoNiveles = false;

            this.continuarCarga();
          },
            () => {
              console.log("Error al cargar los niveles del usuario");
              this.cargandoNiveles = false;
              this.errorNiveles = "Error al cargar los niveles del usuario";

              this.continuarCarga();
            });
      },
      () => {
        console.log("Error al obtener cotizacion dolar.");
        this.errorNiveles = "No se pudo obtener la cotización del dolar, por lo que no podra aprobar refacturación.";
        this.obteniendoAerovales = false;
      });
  }

  continuarCarga() {
    //this.seleccionAerovale();

    this.tablaComprobantes = this.fb.group({
      aerovalesFiltrados: new UntypedFormArray([])
    });
    this.addCheckboxes();


    this.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
    this.idComprobanteAsociado = '';
    this.botonAnular = false;
    this.mensajeSpinner = "C a r g a n d o . . .";

    setTimeout(() => {
      this.spinner.show('spinnerGrafico');
    });
    this.obtenerFechasDeFormulario();
    this.getAprobacionesPorRango();
  }

  filtrarFacturas() {
    this.facturasFiltradas = this.filtrarFacturasPorNivelPermitidoDeUsuario(this.facturas);

    this.facturasFiltradas = this.facturasFiltradas.filter(a => {
      let agregar = true;
      if (this.busqueda.value) {
        agregar = a.factura.razonSocialCliente.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1;

        agregar = agregar || (this.facturacionService.formatearComprobante(a.factura.prefijo,a.factura.numeroComprobante).indexOf(this.busqueda.value) > -1);

        agregar = agregar || (this.datePipe.transform(a.factura.fechaEmision, "d/MM/y").indexOf(this.busqueda.value) > -1);

        agregar = agregar || (this.tipoMovimientoPipe.transform(a.factura.tipoMovimiento).indexOf(this.busqueda.value) > -1);
      }

      return agregar;
    });
  }

  getAprobacionesPorRango() {
    this.obteniendoAerovales = true;
    this.aerovales = [];
    this.aerovalesFiltrados = [];
    this.spinner.show('spinnerGrafico');
    const desde: string = this.sharedService.formatDate(this.startDate.getFullYear(), this.startDate.getMonth() + 1, this.startDate.getDate(), 0, 0);
    const hasta: string = this.sharedService.formatDate(this.endDate.getFullYear(), this.endDate.getMonth() + 1, this.endDate.getDate(), 23, 59);
    this.facturacionService.getRefacturaciones(desde, hasta, EstadoRefacturacion.Revisado)
      .subscribe(result => {
        //this.aerovales = result.sort((a, b) => new Date(b.fechaHoraFinDespacho).getTime() - new Date(a.fechaHoraFinDespacho).getTime());
        //this.aerovalesFiltrados = result;
        this.facturas = result;
        this.facturas = result.filter(f => this.rolRefacturacion ? f.factura.condicionVenta !== CondicionVenta.contado : f.factura.condicionVenta === CondicionVenta.contado)
        this.spinner.hide('spinnerGrafico');
        this.obteniendoAerovales = false;
        this.filtrarFacturas();
      }, () => {
        this.errorAerovales = true;
        this.obteniendoAerovales = false;
      });
  }

  validaMotivos(f: RefacturacionFactura, motivos: number[]){
    if( motivos.find(m => m == f.motivo) == null){
      console.log("No se encontro el motivo de la factura " + f.factura.prefijo + "-" + f.factura.numeroComprobante + " (" + f.motivo + ") en los motivos del usuario: " + JSON.stringify(motivos) + ".")
      return false;
    }else{
      return true;
    }
  }

  filtrarFacturasPorNivelPermitidoDeUsuario(facturas: RefacturacionFactura[]) {
    this.mensajeNivelUsuario = null;
    const usuarioNiveles = this.facturacionService.getNivelUsuarioLogueado();

    const totalFacturas = facturas.length;

    const facturasFiltradas = facturas.filter(f => {
    const valorValidarPesos = (f.factura.tipoMoneda == TipoMoneda.PES ? f.valorAAnular : f.valorAAnular * this.cotizacionDolar) ;

    const valorMaximoAprobacionPesos = usuarioNiveles?.nivelNativo? usuarioNiveles?.nivelNativo.montoMaximoAprobacion * this.cotizacionDolar : 0;

    if (usuarioNiveles && valorMaximoAprobacionPesos >= valorValidarPesos) {

      if(this.validaMotivos(f, usuarioNiveles?.nivelNativo.motivos)){
        return true;
      }
    }

    if (usuarioNiveles && usuarioNiveles.nivelesDelegados) {
      for (const nivelDelegado of usuarioNiveles.nivelesDelegados) {
        const valorMaximoAprobacionPesos = nivelDelegado.montoMaximoAprobacion * this.cotizacionDolar;

        if (valorMaximoAprobacionPesos >= valorValidarPesos) {
          if(this.validaMotivos(f, nivelDelegado.motivos)){
            return true;
          }
        }
      }
    }

      return false;
    });

    const totalFiltradas = facturasFiltradas.length;

    if (usuarioNiveles == null) {
      this.mensajeNivelUsuario = "Se obtuvieron " + totalFacturas + " registros pero no puede visualizarlos porque no se obtuvo su nivel de usuario para verificar si puede aprobar estos registros.";
    } else {
      if (totalFiltradas < totalFacturas) {
        this.mensajeNivelUsuario = "Podrá trabajar " + totalFiltradas + " registros de un total de " + totalFacturas + " obtenidos. El resto de registros no los puede visualizar porque su nivel de aprobación no lo permite (su monto maximo de aprobación es: USD " + this.calcularMaximoAprobacionNivelUsuario(usuarioNiveles) + ").";
      }
    }

    return facturasFiltradas;
  }

  calcularMaximoAprobacionNivelUsuario(usuarioNiveles) {
    let maximo = 0;

    if(usuarioNiveles?.nivelNativo !=null)
    if (usuarioNiveles && usuarioNiveles.nivelNativo.montoMaximoAprobacion > maximo) {
      maximo = usuarioNiveles.nivelNativo.montoMaximoAprobacion;
    }

    if (usuarioNiveles) {
      for (const nivelDelegado of usuarioNiveles.nivelesDelegados) {
        if (nivelDelegado.montoMaximoAprobacion > maximo) {
          maximo = nivelDelegado.montoMaximoAprobacion;
        }
      }
    }

    return maximo;
  }

  ngOnDestroy() {
    this.change$.unsubscribe();
    this.aerovalesFiltrados = [];
  }

  addValidationError(control: AbstractControl, validationName: string) {
    let errors = control.errors;
    if (errors == null)
      errors = { [validationName]: true };
    else
      errors[validationName] = true;
    control.setErrors(errors);
    control.markAsDirty();
  }

  /**
   * Convierte una NgbDateStruct y una NgbTimeStruct en un Date
   */
  dateFromDateTimeStruct(date: NgbDateStruct, hour: NgbTimeStruct): Date {
    if (date == null || hour == null)
      return null;
    const dateReturn = new Date();
    dateReturn.setDate(date.day);
    dateReturn.setMonth(date.month - 1);
    dateReturn.setFullYear(date.year);
    dateReturn.setHours(hour.hour);
    dateReturn.setMinutes(hour.minute);
    return dateReturn;
  }

  fechaDesdeMayorQueHasta() {
    let esMayor: boolean = false;
    this.startDate = new Date(this.model.year, this.model.month - 1, this.model.day);
    this.endDate = new Date(this.model1.year, this.model1.month - 1, this.model1.day);
    if (this.startDate > this.endDate) { esMayor = true; }
    return esMayor;
  }


  obtenerFechasDeFormulario() {
    this.startDate = new Date(this.model.year, this.model.month - 1, this.model.day);
    this.endDate = new Date(this.model1.year, this.model1.month - 1, this.model1.day);
    this.endDate.setHours(23, 59, 59, 99);
  }

  buscarDesdeHasta() {
    this.facturasSeleccionadas = [];
    this.mensajeErrorExportar = "";
    this.aerovalesFiltrados = null;
    this.aerovaleActual = null;
    this.mensajeSpinner = "C a r g a n d o . . .";
    this.buscando = true;
    this.obtenerFechasDeFormulario();
    this.getAprobacionesPorRango();

    //this.aerovalesFiltrados.splice(0, this.aerovalesFiltrados.length);

    //this.buscando = false;
  }

  verObservaciones(motivos: string) {
    console.log("El datelle es " + JSON.stringify(motivos));
    const modalRef = this.modalService.open(MotivosObservacionesComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.tipoObservacion = TipoModalObservacion.Refacturacion;
    modalRef.componentInstance.motivos = motivos;
    modalRef.componentInstance.titulo = "Observaciones";
  }

  verComparativasFacturas(content, s: RefacturacionFactura, index) {
    this.cargandoPrevisualizacion = true;
    this.itemSeleccionado = index;
    this.tituloFactura = 'Factura: ' + s.factura.prefijo + '-' + s.factura.numeroComprobante + ' Fecha: ' + new Date().toLocaleDateString();
    this.comprobanteService.obtenerComprobantePorPrefijoNumeroTipo(s.factura.prefijo, s.factura.numeroComprobante, s.factura.tipoMovimiento)
      .subscribe(result => {
        this.facturaObtenida = result;
        if (result != null) {
          this.previsualizacion = false;
          this.facturacionService.getNuevoComprobante(s.id, s.esRefacturacionTotal)
            .subscribe(result => {
              this.facturaCalculada = result;
              this.previsualizacion = true;
              this.itemSeleccionado = -1;
              this.cargandoPrevisualizacion = false;
              this.modalService.open(content, { windowClass: 'custom-modal', centered: true, size: 'lg' });
            }, (err: ErrorModel) =>{
              this.previsualizacion = true;
              this.itemSeleccionado = -1;
              this.cargandoPrevisualizacion = false;
              this.messageService.showErrorMessage('Hubo un error al obtener la comparativa. ' + err.description + ' ' + err.message);
            });
        }
        else {
          this.cargandoPrevisualizacion = false;
          this.itemSeleccionado = -1;
          this.facturaObtenida = null; //se limpia el comprobante.
        }
      },
        () => {
          // Entra aquí si el servicio entrega un código http de error EJ: 404,
          //500
          this.cargandoPrevisualizacion = false;
          this.itemSeleccionado = -1;
          this.facturaObtenida = null; //se limpia el comprobante.
        });
  }

  delegarNivelNativoRefacturacion() {
    const modalRef = this.modalService.open(ModalSeleccionarUsuarioComponent, { centered: true });
    modalRef.componentInstance.esDelegacion = true;
    modalRef.componentInstance.nivelAprobacion = this.facturacionService.getNivelUsuarioLogueado() != null ? this.facturacionService.getNivelUsuarioLogueado().nivelNativo : null;
    modalRef.result.then(() => {
      this.messageService.showSuccessMessage("Se delego su nivel correctamente al usuario");
    });
  }

  usuarioPuedeDelegar() {
    try {
      const usuarioNiveles = this.facturacionService.getNivelUsuarioLogueado();

      if(usuarioNiveles?.nivelNativo != null)
      {
        //Solo se puede delegar si se tiene nivel nativo de refacturacion
        if (usuarioNiveles && usuarioNiveles.nivelNativo.tipoNivel == tipoNivelUsuarioSeparados.Refacturacion) {
          return true;
        }
      }

      return false;
    } catch (ex) {
      console.log(ex);
      return false;
    }
  }

  limpiarCampos() {
    this.aerovalesFiltrados = [];
    this.spinner.hide("spinnerGrafico");
    this.spinner.hide("spinnerDetalle");
    this.buscando = false;
    this.busquedaFormControl.reset();
    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();

  }

  cambiarDeAeroplanta() {
    this.cambiandoAeroplanta = false;
    this.limpiarCampos();
    this.cambiandoAeroplanta = true;
    this.ngOnInit();
  }

  private addCheckboxes() {
    // reinicio el formulario
    this.tablaComprobantes.setControl('aerovalesFiltrados', this.fb.array([]));
    this.aerovalesFiltrados.map((o, i) => {
      const control = new UntypedFormControl(i === 0); // if first item set to true, else false
      control.setValue(o);
      (this.tablaComprobantes.controls.aerovalesFiltrados as UntypedFormArray).push(control);
    });
  }

  seleccionarFactura(factura) {
    const indice = this.facturasSeleccionadas.indexOf(factura);
    if (indice != -1) {
      this.facturasSeleccionadas.splice(indice, 1);
    } else {
      this.facturasSeleccionadas.push(factura);
    }
  }



  aprobarRefactura() {
    this.aceptandoRefacturacion = true;

    const refacturacion = new RefacturacionFactura();
    const tupla: TuplaRefacturacion[] = [];

    for (const fact of this.facturasSeleccionadas) {
      const t = new TuplaRefacturacion();
      t.esRefacturacionTotal = fact.esRefacturacionTotal;
      t.refacturacionFacturaId = fact.id
      tupla.push(t);
    }
    refacturacion.tupla = tupla;
    refacturacion.responsable = this.obtenerStringUsuarioSolicitador();
    refacturacion.estado = EstadoRefacturacion.Revisado;
    refacturacion.estadoFinal = EstadoRefacturacion.Aprobado;
    this.facturacionService.actualizarRefacturacion(refacturacion)
      .subscribe(result => {
        this.aceptandoRefacturacion = false;
        this.facturasSeleccionadas = [];
        try{
          const modalRef_ = this.activeModal.open(ModalOkComponent, { centered: true, backdrop: 'static' });
          modalRef_.componentInstance.titulo = 'Resultado del proceso de aprobar refacturación:';
          const respuesta = result.split('*|*').join('<br/>');
          modalRef_.componentInstance.mensaje = respuesta;
        }catch(ex){
          this.messageService.showSuccessMessage("Se ha realizado correctamente el proceso de aprobado de la refacturación");
        }
        this.ngOnInit();
      }, (err: ErrorModel) => {
        this.facturasSeleccionadas = [];
        this.messageService.showErrorMessage("Hubo un error al realizar la refacturación. " + err.description + ' ' + err.message);
        this.aceptandoRefacturacion = false;
      });

  }

  rechazarRefactura() {
    if (this.facturasSeleccionadas.length == 0) {
      this.messageService.showErrorMessage('No se seleccionó ninguna factura para rechazar.');
      return;
    } else {

      const modalRef = this.modalService.open(ModalMotivoRechazoComponent, { size: 'lg', backdrop: 'static' });
      modalRef.result.then((motivo) => {
        if (motivo == null) {
          return;
        }

        this.accionRechazar(motivo);
      }).catch(() => {
        return;
      });
    }
  }

  accionRechazar(motivo) {
    this.rechazandoRefacturacion = true;

    const refacturacion = new RefacturacionFactura();
    const tupla: TuplaRefacturacion[] = [];

    for (const fact of this.facturasSeleccionadas) {
      const t = new TuplaRefacturacion();
      t.esRefacturacionTotal = fact.esRefacturacionTotal;
      t.refacturacionFacturaId = fact.id
      tupla.push(t);
    }
    refacturacion.tupla = tupla;
    refacturacion.responsable = this.obtenerStringUsuarioSolicitador();
    refacturacion.estado = EstadoRefacturacion.Revisado;
    refacturacion.estadoFinal = EstadoRefacturacion.Rechazado;
    refacturacion.motivoRechazo = motivo;
    this.facturacionService.actualizarRefacturacion(refacturacion)
      .subscribe(() => {
        this.facturasSeleccionadas = [];
        this.rechazandoRefacturacion = false;
        this.messageService.showSuccessMessage("Se ha realizado correctamente el aprobado de la refacturación");
        this.ngOnInit();
      }, (err: ErrorModel) => {
        this.facturasSeleccionadas = [];
        this.messageService.showErrorMessage("Hubo un error al realizar el aprobado de la refacturación. " + err.description + ' ' + err.message);
        this.rechazandoRefacturacion = false;
      });
  }

  // getters
  obtenerMotivoRefacturacion(numero: string) {
    return Motivo[numero];
  }

  obtenerEstadoRefacturacion(numero: string) {
    return EstadoRefacturacion[numero];
  }

  obtenerStringUsuarioSolicitador() {
    return this.facturacionService.obtenerStringSolicitador();
  }

  obtenerNuevoComprobante(id: string) {
    this.previsualizacion = false;
    // this.obteniendoFactura = true;
    this.facturacionService.getNuevoComprobante(id, true)
      .subscribe(result => {
        this.facturaCalculada = result;
        //this.spinner.hide('spinnerFactura');
        //this.obteniendoFactura = false;
        this.previsualizacion = true;
      })

  }

  get busqueda() {
    return this.busquedaFormControl;
  }

}
